import React from "react";

import { IBaseField } from "../models/formFields.interfaces";
import { AbstractFormField, IFormFieldState } from "./AbstractFormField";

// TODO(ssr, LEVEL 3 out of 10): Migrate to functional component
// Complexity: Simple type adapter with minimal logic. Only implements updateValueAttribute() to
// specialize AbstractFormField for HTMLSelectElement. No lifecycle methods or complex state.
// Migration: Replace with generic type constraint in useFormField hook. After AbstractFormField is
// migrated to hooks, this can become a simple type parameter like useFormField<HTMLSelectElement>.
// The updateValueAttribute logic (event.currentTarget.value) becomes part of the hook's onChange
// handler. Very straightforward once parent AbstractFormField migration is complete.
export abstract class AbstractSelect<
    FieldName extends string,
    IProps extends IBaseField<HTMLSelectElement, FieldName>,
    IState extends IFormFieldState,
> extends AbstractFormField<FieldName, HTMLSelectElement, IProps, IState> {
    protected updateValueAttribute(
        event: React.FormEvent<HTMLSelectElement>,
    ): void {
        this.value = event.currentTarget.value;
    }
}
